<app-tooltip-template label="reports.name"
                      *ngIf="data.attributes?.name">
  {{ data.attributes.name }}</app-tooltip-template>
